import { render, staticRenderFns } from "./NewPaymentsPayoneerEdit.vue?vue&type=template&id=6b04c841&scoped=true"
import script from "./NewPaymentsPayoneerEdit.vue?vue&type=script&lang=js"
export * from "./NewPaymentsPayoneerEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b04c841",
  null
  
)

export default component.exports